// 1 minute to 99 hours, matching the backend's EnvironmentCreate/EnvironmentUpdate range.
export const AUTO_STOP_IDLE_MINUTES_MIN = 1;
export const AUTO_STOP_IDLE_MINUTES_MAX = 99 * 60;
